import React from 'react'
import BlogDetailContent from './BlogDetailContent'
import BlogDetailCards from './BlogDetailCards'

export default function BlogDetails({initialData}) {
  return (
  <>
  
  <BlogDetailContent initialData={initialData?.detailpage}/>
  <BlogDetailCards initialData={initialData?.listpage}/>
  
  </>
  )
}
